import btoa from 'btoa';
import type { CvnaId } from '~/contracts/common';
import { isDefined } from '~/utilities/array';

export default function generateSearchLinkFilter(cvnaid: CvnaId) {
  if (Object.values(cvnaid).some(isDefined)) {
    const url = new URL('/cars/filters', 'https://www.dummy.com');
    url.searchParams.set('cvnaid', btoa(JSON.stringify(cvnaid)));

    return url.pathname + url.search;
  }

  return '/cars';
}
